import type { AddressFormInput } from '@klareospace/pharos-lib-front-utils';
import { buildSiteLocation } from '@klareospace/pharos-lib-front-utils';
import type { PhoneNumber } from '@klareospace/pharos-lib-types';

export { buildSiteLocation };

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function hasAddressData(address: AddressFormInput | undefined): boolean {
  return (
    address !== undefined &&
    typeof address.city === 'string' &&
    address.city.trim().length > 0 &&
    typeof address.country === 'string' &&
    address.country.trim().length > 0 &&
    typeof address.postalCode === 'string' &&
    address.postalCode.trim().length > 0
  );
}

export function hasPhoneData(phone: PhoneNumber | null | undefined): phone is PhoneNumber {
  return phone !== null && phone !== undefined && phone.dialCode !== '' && phone.number !== '';
}
